/**
 * Build version tag. Bump on every user-visible change so a glance at the
 * corner of the screen tells you whether the browser is actually running
 * the new build (vs. a cached or not-yet-deployed one).
 */
export const VERSION = '0.53.8-compact-hud';
